import { render } from "./ReturnBox.vue?vue&type=template&id=bdfbbd22"
import script from "./ReturnBox.vue?vue&type=script&lang=js"
export * from "./ReturnBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__